import type { DefaultDashboardDefinition } from './dashboard-definition';

export const departmentDashboard: DefaultDashboardDefinition = {
  id: "configuration.department",
  appId: "configuration",
  name: "Department dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: "."
  },
  queryScope: null,
  placements: [
    {
      id: "organisation.summary.department.employees",
      widgetId: "organisation.summary.department.employees",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.department.children",
      widgetId: "organisation.summary.department.children",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.department.positions",
      widgetId: "organisation.summary.department.positions",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.department.branches",
      widgetId: "organisation.summary.department.branches",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 1
      }
    }
  ]
};
